import { TAGS } from "../constants";
import { ClientSecret } from "../types";
import { api } from "./api";

export const paymentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createSetupIntent: builder.mutation<
      ClientSecret,
      { payment_customer_id: string }
    >({
      query: (body) => ({
        method: "POST",
        url: `/api/payments/setup-intent`,
        body,
      }),
      invalidatesTags: [TAGS.PAYMENT_METHODS],
    }),
  }),
});

export const { useCreateSetupIntentMutation } = paymentsApi;
